module.exports = __webpack_public_path__ + "img/analytics.b172feba.svg";